import { CloseButton, CrudMode, ListContext, ListContextValue, Stack, newToast } from "@compass/core";
import { SubmitButton } from "components";
import {
  ApplicationResponseFile,
  FileTypeCategory,
  StudentFile,
  StudentServiceFile,
} from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { FileDetailTypeEnum } from "./FileDetailTypeEnum";
import { useContext } from "react";

export const FileDetailHeader = (props: {
  crudMode: CrudMode;
  entityId: Number;
  fileType: FileTypeCategory;
  fetch: (id: number) => void;
  reroute: (id: number, crudMode: CrudMode) => void;
  applicationResponseFile: ApplicationResponseFile | undefined;
  studentFile: StudentFile | undefined;
  studentServiceFile: StudentServiceFile | undefined;
  onSave: (id: number) => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);

  const save = () => {
    // props.setValidationErrors({});
    if (props.entityId == 0) {
      if (props.fileType == FileTypeCategory.Application && props.applicationResponseFile) {
        ApiService.studentApplications.saveCreateFile(props.applicationResponseFile)
          .then((applicationResponseFileId) => {
            props.reroute(applicationResponseFileId, "view");
            props.fetch(applicationResponseFileId);
            listContext.loadList?.();
            dispatch(setAppToast(newToast("success")));
          })
          .catch((ex) => {
            dispatch(setAppToast(newToast("error")));
          });
      }
      else if (props.fileType == FileTypeCategory.StudentServiceFile && props.studentServiceFile) {
        ApiService.studentServices.saveCreateStudentFile(props.studentServiceFile)
          .then((studentServiceFileId) => {
            props.reroute(studentServiceFileId, "view");
            props.fetch(studentServiceFileId);
            listContext.loadList?.();
            dispatch(setAppToast(newToast("success")));
          })
          .catch((ex) => {
            dispatch(setAppToast(newToast("error")));
          });
      }
      else if (props.fileType == FileTypeCategory.StudentFile && props.studentFile) {
        ApiService.studentFiles.saveCreate(props.studentFile)
          .then((studentFileId) => {
            props.reroute(studentFileId, "view");
            props.fetch(studentFileId);
            listContext.loadList?.();
            dispatch(setAppToast(newToast("success")));
          })
          .catch((ex) => {
            dispatch(setAppToast(newToast("error")));
          });
      }
    }
    else {
      if (props.fileType == FileTypeCategory.Application && props.applicationResponseFile) {
        ApiService.studentApplications.saveCreateFile(props.applicationResponseFile)
          .then((applicationResponseFileId) => {
            props.reroute(applicationResponseFileId, "edit");
            props.fetch(applicationResponseFileId);
            listContext.loadList?.();
            dispatch(setAppToast(newToast("success")));
          })
          .catch((ex) => {
            dispatch(setAppToast(newToast("error")));
          });
      }
      else if (props.fileType == FileTypeCategory.StudentServiceFile && props.studentServiceFile) {
        ApiService.studentServices.saveUpdateStudentFile(props.studentServiceFile)
          .then((studentServiceFileId) => {
            props.reroute(studentServiceFileId, "edit");
            props.fetch(studentServiceFileId);
            listContext.loadList?.();
            dispatch(setAppToast(newToast("success")));
          })
          .catch((ex) => {
            dispatch(setAppToast(newToast("error")));
          });
      }
      else if (props.fileType == FileTypeCategory.StudentFile && props.studentFile) {
        ApiService.studentFiles.saveUpdate(props.studentFile)
          .then((studentFileId) => {
            props.reroute(studentFileId, "edit");
            props.fetch(studentFileId);
            listContext.loadList?.();
            dispatch(setAppToast(newToast("success")));
          })
          .catch((ex) => {
            dispatch(setAppToast(newToast("error")));
          });
      }
    }
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        Upload File
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton />

        <SubmitButton
          onClick={() => save()}
          disabled={(props.crudMode != "edit")}
        />
      </Stack>
    </Stack>
  );
};
